import { useEffect, useRef, useState } from "react";
// Jds
import {
  Container,
  Text,
  Notifications,
  Button,
  Image as UIImage,
} from "@jds/core";
// Mui
import { Box } from "@mui/material";
//Img
import noFrameStateImg from "../../../assets/png/no-frame.png";
import port from "../../../assets/portrait.jpg";
import land from "../../../assets/landscape.jpg";
//helper
import { imgValidationCheck } from "../../../util/helper";
import useApiHttp from "../../../hooks/use-http";
import { useParams } from "react-router-dom";
import PageLoader from "../Loader/PageLoader";
import decryptUrl from "../../../util/img-decryption";

const FrameModal = (props) => {
  const { closeModal } = props;
  const [frameData, setFrameData] = useState();
  const { id: eventId } = useParams();
  const frameFileInputRef = useRef(null);
  const portFrameFileInputRef = useRef(null);
  const { sendRequest: frameUpload, isLoading: frameUploading } = useApiHttp();
  const { sendRequest: getFrame, isLoading: frameGetting } = useApiHttp();
  const { sendRequest: deleteFrame, isLoading: frameDeleting } = useApiHttp();
  const handleUploadFrameClick = () => {
    frameFileInputRef.current.click();
  };
  const handleUploadPortFrameClick = () => {
    portFrameFileInputRef.current.click();
  };
  const hadleFrameFileChange = (event) => {
    const selectedFiles = Array.from(event.target.files);
    if (selectedFiles.length !== 2) {
      Notifications.toast.error({
        id: "frame-input-img",
        title: "Please select the two files.",
      });
      return;
    }
    if (
      !imgValidationCheck(null, selectedFiles[0]) ||
      !imgValidationCheck(null, selectedFiles[1])
    ) {
      Notifications.toast.error({
        id: "frame-input-img",
        title: "Please upload a valid image file (JPG, JPEG and PNG).",
      });
      event.target.value = "";
      return;
    }

    const imagePromises = selectedFiles.map((file) => {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = (e) => {
          const img = new Image();
          img.onload = () => {
            resolve({
              file,
              width: img.width,
              height: img.height,
            });
          };
          img.onerror = reject;
          img.src = e.target.result;
        };
        reader.readAsDataURL(file);
      });
    });

    Promise.all(imagePromises)
      .then((loadedImages) => {
        const isPortrait = (img) => img.height >= img.width;
        const portraitImage = loadedImages.find(isPortrait);
        const landscapeImage = loadedImages.find((img) => !isPortrait(img));
        if (portraitImage && landscapeImage) {
          const formData = new FormData();
          formData.append("eventId", eventId);
          formData.append("portraitFrame", portraitImage.file);
          formData.append("landscapeFrame", landscapeImage.file);
          // formData.append("frameStatus", true);
          frameUpload(
            {
              url: "event/frame/uploadFrame",
              method: "POST",
              formData: true,
              body: formData,
            },
            null,
            (data) => {
              closeModal && closeModal();
              Notifications.toast.success({
                id: "frame-input-img",
                title: data?.message,
              });
            },
            (err, data) => {
              Notifications.toast.error({
                id: "frame-input-img",
                title: data?.message,
              });
            }
          );
        } else {
          Notifications.toast.error({
            id: "frame-input-img",
            title: "Please select one portrait and one landscape image.",
          });
          event.target.value = "";
        }
      })
      .catch(() => {
        Notifications.toast.error({
          id: "frame-input-img",
          title: "Please upload a valid image file (JPG, JPEG and PNG).",
        });
      });
  };
  const hadlePortFrameFileChange = (event) => {
    const selectedFiles = event.target.files;
    if (!selectedFiles || selectedFiles.length === 0) return;
    const formData = new FormData();
    formData.append("eventId", eventId);
    formData.append("portraitFrame", selectedFiles[0]);

    // formData.append("frameStatus", true);
    frameUpload(
      {
        url: "event/frame/uploadFrame",
        method: "POST",
        formData: true,
        body: formData,
      },
      null,
      (data) => {
        closeModal && closeModal();
        Notifications.toast.success({
          id: "frame-input-img",
          title: data?.message,
        });
      },
      (err, data) => {
        Notifications.toast.error({
          id: "frame-input-img",
          title: data?.message,
        });
      }
    );
    event.target.value = null;
  };
  const handleDeleteFrame = () => {
    deleteFrame(
      {
        url: `event/frame/delete-frame?eventId=${eventId}`,
        method: "DELETE",
      },
      null,
      (data) => {
        closeModal && closeModal();
        Notifications.toast.success({
          id: "frame-delete",
          title: "Frame deleted successfully.",
        });
      },
      (err, data) => {
        closeModal && closeModal();
        Notifications.toast.error({
          id: "frame-delete",
          title: data?.message,
        });
      }
    );
  };
  useEffect(() => {
    getFrame(
      {
        url: `event/frame/frame-details?eventId=${eventId}`,
        method: "GET",
      },
      null,
      (data) => {
        setFrameData(data?.data);
      },
      (err, data) => {
        console.log("error", data);
      }
    );
  }, []);
  return (
    <Container
      fullWidth
      direction="column"
      horizontalAlign="center"
      gap={"40px"}
    >
      {frameData?.portraitFrameThumbnailUrl ||
      frameData?.landscapeFrameThumbnailUrl ? (
        <div>
          {frameData?.portraitFrameThumbnailUrl && (
            <div
              style={{
                position: "relative",
                width: "400px",
              }}
            >
              <img
                src={frameData?.portraitFrameThumbnailUrl || ""}
                style={{
                  objectFit: "cover",
                  width: "100%",
                  height: "600px",
                }}
              />
              <img
                src={port}
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  objectFit: "cover",
                  zIndex: -10,
                  width: "400px",
                  height: "600px",
                }}
              />
            </div>
          )}
          {frameData?.landscapeFrameThumbnailUrl && (
            <div
              style={{
                position: "relative",
                width: "200px",
              }}
            >
              <img
                src={frameData?.landscapeFrameThumbnailUrl || ""}
                style={{
                  objectFit: "cover",
                  width: "100%",
                  height: "100%",
                }}
              />
              <img
                src={land}
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  objectFit: "cover",
                  zIndex: -10,
                  width: "100%",
                  height: "100%",
                }}
              />
            </div>
          )}
        </div>
      ) : (
        <>
          <Container fullWidth horizontalAlign="center">
            <Text
              appearance="body-m-bold"
              color="primary-grey-80"
              text="Please upload frame with portrait orientation."
              textAlign="center"
            />
          </Container>

          <Box width={176}>
            <img src={noFrameStateImg} alt="photo frame" />
          </Box>
        </>
      )}

      <Container fullWidth horizontalAlign="center" direction="column" gap={16}>
        <input
          type="file"
          id="photo_frame"
          name="frame_img"
          accept=".jpeg,.jpg,.png"
          style={{ display: "none" }}
          multiple
          onChange={(e) => {
            hadleFrameFileChange(e);
          }}
          ref={frameFileInputRef}
        />
        <input
          type="file"
          id="photo_frame"
          name="frame_img"
          accept=".jpeg,.jpg,.png"
          style={{ display: "none" }}
          onChange={(e) => {
            hadlePortFrameFileChange(e);
          }}
          ref={portFrameFileInputRef}
        />
        <Container fullWidth horizontalAlign="center" gap={16}>
          {/* two frames */}
          {/* <Button
            label="Upload Frame"
            iconLeft={"IcAdd"}
            size="large"
            onClick={handleUploadFrameClick}
          /> */}
          <Button
            label="Upload Frame"
            iconLeft={"IcAdd"}
            size="large"
            onClick={handleUploadPortFrameClick}
          />
          {(frameData?.portraitFrameThumbnailUrl ||
            frameData?.landscapeFrameThumbnailUrl) && (
            <Button
              label="Delete Frame"
              iconLeft={"IcTrash"}
              size="large"
              onClick={handleDeleteFrame}
              kind="secondary"
            />
          )}
        </Container>
        {/* <Text
          text="Upload frames with dimensions 6144 X 6144"
          appearance="body-xs"
          color="primary-grey-80"
        /> */}
      </Container>
      <PageLoader open={frameUploading || frameGetting || frameDeleting} />
    </Container>
  );
};

export default FrameModal;
